import type { ExpenseCategory, GstTreatment } from "@/types/tax";

export const expenseCategoryLabels: Record<ExpenseCategory, string> = {
  fuel: "Fuel",
  ev_charging: "EV charging / electricity",
  tolls: "Tolls",
  parking: "Parking",
  registration: "Registration",
  insurance: "Insurance",
  platform_fees: "Platform service fees / commission",
  booking_fees: "Booking fees",
  service_repairs: "Car service / repairs",
  tyres: "Tyres",
  car_wash: "Car wash / cleaning",
  lease_rental: "Lease / rental",
  car_purchase: "Car purchase / depreciating asset",
  mobile_phone: "Mobile phone / device / plan",
  passenger_supplies: "Passenger supplies",
  cleaning_safety: "Sanitiser / wipes / safety supplies",
  driver_accreditation: "Driver accreditation / checks",
  tax_agent: "Tax agent / accounting fees",
  other: "Other business expense",
};

export const categoryHelp: Record<ExpenseCategory, string> = {
  fuel: "Claim the business-use portion of GST included in fuel.",
  ev_charging: "Use a business-use percentage and keep evidence of charging costs.",
  tolls: "Passenger-paid tolls may still create an offsetting GST credit.",
  parking: "Only claim parking connected to earning rideshare income.",
  registration: "Apportion between business and private use.",
  insurance: "Apportion between business and private use.",
  platform_fees: "Claim GST only if the platform fee includes GST.",
  booking_fees: "Claim GST only if GST is charged on the fee.",
  service_repairs: "Apportion vehicle servicing between business and private use.",
  tyres: "Apportion vehicle costs between business and private use.",
  car_wash: "Claim the business-use portion when related to rideshare work.",
  lease_rental: "Apportion lease or rental costs between business and private use.",
  car_purchase: "Car cost limit and business timing rules may apply.",
  mobile_phone: "Claim the rideshare business portion of phone costs.",
  passenger_supplies: "Claim items provided for passenger use where GST is included.",
  cleaning_safety: "Claim supplies used for passengers or vehicle cleaning for rideshare work.",
  driver_accreditation: "Private driver licence costs are private, but commercial approvals may be deductible.",
  tax_agent: "Tax agent and accounting fees may be business expenses.",
  other: "Use only for business purchases with clear evidence.",
};

export const gstTreatmentLabels: Record<GstTreatment, string> = {
  gst_included: "GST included",
  no_gst: "No GST / GST-free",
  supplier_not_registered: "Supplier not GST-registered",
  manual_gst: "Enter GST amount",
  mixed_invoice: "Mixed invoice",
};

export const atoRuleCards = [
  {
    title: "Ride-sourcing is taxi travel for GST",
    body: "ATO guidance says rideshare drivers need an ABN and GST registration regardless of the $75,000 turnover threshold.",
  },
  {
    title: "GST applies to the full fare",
    body: "Calculate GST on the full passenger fare, not on the net payout after platform fees.",
  },
  {
    title: "Business-use apportionment",
    body: "For mixed private and rideshare use, only the business portion of GST can be claimed as a credit.",
  },
  {
    title: "Tax invoices matter",
    body: "Purchases over A$82.50 including GST need a valid tax invoice before the GST credit is included.",
  },
  {
    title: "Fuel tax credits excluded",
    body: "Fuel used in light vehicles on public roads for rideshare is not eligible for fuel tax credits.",
  },
];

export const gstBlockedReasons: Partial<Record<GstTreatment, string>> = {
  no_gst: "No GST credit is available when the purchase is GST-free or has no GST.",
  supplier_not_registered: "A supplier that is not GST-registered cannot charge GST.",
};
